import React, { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import {  useSelector } from 'react-redux'
import { Button }  from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useGetPublicplansQuery } from '../../slices/teachers/planApiSlice';
import { useGetPlanQuestionsQuery, useGetPublicsubjectQuery } from '../../slices/teachers/subjectApiSlice';
import { useGetProfileQuery } from '../../slices/students/studentsApiSlice';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import SubscriptionPlan from '../../components/SubscriptionPlan';

const StudentPlans =  () => {

    const navigate = useNavigate();
    const { id } = useParams();

    let mergedArray;
    const [questionsLeft, setQuestionsLeft] = useState(0);
    const [currentPlan, setCurrentPlan] = useState([]);
    const [stillplan, setStillplan] = useState([]);
    const [lastdate, setLastdate] = useState();
    const [isoneactive, setIsoneactive] = useState(false);
    const [isonestrill, setIsonestrill] = useState(false);
    const [isonepastdue, setIsonepastdue] = useState(false);
    const [mergedArray2, SetMergedArray2] = useState([]);
    const [isCoursePublish, setIsCoursePublish] = useState('');

    const  { data: data3, error: error3,   isLoading :isLoading3, refetch :refetch2  } =  useGetProfileQuery();
    const { data: plansData, error: plansError, isLoading: plansIsLoading } = useGetPublicplansQuery(id);
    const { data: data2, isLoading, error, refetch } = useGetPlanQuestionsQuery(id);
    const { data: subjectData, errorSubject, isLoadingSubject } = useGetPublicsubjectQuery(id);

    const { studentInfo } = useSelector((state) => state.authStudent);

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }   
    }, [navigate, studentInfo])

    
     useEffect(() => {
        mergedArray = plansData?.map(plan => {
            const matchingData2 = data2?.find(data => data.plan === plan._id);
            if (matchingData2) {
            return {
                ...plan, 
                active2: matchingData2.active, 
                renewal: matchingData2.renewal, 
                pastDue: matchingData2.pastDue, 

            };
        }
        return plan; 
      });
      
      SetMergedArray2(mergedArray);
     }, [data2, plansData])

    useEffect(() => {
        data2?.map((pla) => {
        if (pla.active == true && pla.renewal == true) {
          setCurrentPlan(pla)
          setIsoneactive(true);
        }
        if (pla.active == true &&  pla.renewal == false &&  pla.questionsLeft > 0) {
            setStillplan(pla)
            setIsonestrill(true);
        }

        if (pla.active == true &&  pla.pastDue == true) {
            setIsonestrill(true);
            setIsonepastdue(true);
        }

      });
    }, [navigate, data2])


    useEffect(() => {
        if(currentPlan) {
          setQuestionsLeft(currentPlan.questionsLeft)  
          setLastdate(new Date(currentPlan.endDate * 1000).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}))  
        }
        if(currentPlan?.length == 0 && stillplan?.questionsLeft > 0) {
            setQuestionsLeft(stillplan.questionsLeft)  
            setLastdate(new Date(stillplan.endDate * 1000).toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}))  
          }

    }, [navigate, currentPlan, stillplan, data2])

    useEffect(() => {
        refetch();
        refetch2();
      }, []);

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader /><br /><br /><br />
            <div className="container-fluid mt--6 plansSpac">
                <div className="row ">
                    <h3 className=" tittleColor4 ">
                        <span className='tittleColor4'>
                            Subscribe or cancel a plan for&nbsp;  
                             <span  style={{ textTransform: 'capitalize' }}>{subjectData?.tittle} </span>
                             </span>
                    </h3> 
                    <h6 className="centerTitle tittleColor4 ">
                        {isLoading ? ( 
                            <Loader />
                        ) : error ? (
                            <Message variant='danger'>
                                {error?.data?.message || error.error}
                            </Message>
                        ) : (
                            <div>
                                { currentPlan.active  ?    (  
                                    <>                                                      
                                        { (currentPlan.active  && currentPlan.pastDue == false)  &&               
                                                <span className='tittleColor4'>
                                                    You have  {questionsLeft}  questions left this month  <br />
                                                </span>
                                        }
                                        { (currentPlan.active && currentPlan.renewal  && currentPlan.pastDue == false ) &&                              
                                                <span className='tittleColor4'>
                                                    Your Subscription will renew on {lastdate}
                                                </span>
                                        }
                                        { (currentPlan.active && currentPlan.pastDue) &&                              
                                                <span className='tittleColor4'>
                                                    Your Subscription is past due
                                                </span>
                                        }
                                        { (currentPlan.active && currentPlan.renewal == false  && currentPlan.pastDue == false ) ?               
                                                <span className='tittleColor4'>
                                                Your Subscription will experire on {lastdate}
                                                </span>
                                            : 
                                                <span className='tittleColor4'>
                                                </span>
                                        }
                                    </>
                                ) : (
                                    <>
                                    {stillplan?.questionsLeft  > 0 && 
                                        <span className='tittleColor4'>
                                                    You have  {questionsLeft}  questions left this month  <br />
                                                    Your Subscription will experire on {lastdate}
                                                </span>                                   
                                    }
                                    </>                                    
                                )}
                            </div>
                        )} 
                     </h6>
                    <div className="plansSpac">            
                        <div className=" ">
                            <div className="">
                                <div className="pricing2   ">
                                    {plansIsLoading ? ( 
                                        <Loader />
                                    ) : plansError ? (
                                        <Message variant='danger'>
                                            {plansError?.data?.message || plansError.error}
                                        </Message>
                                    ) : (
                                        <div className="row pricecard3"  >
                                            {mergedArray2?.map((plan) => (
                                                <div key={plan._id} className="col-md-6 col-xl-4 pricecard2 ">
                                                    <SubscriptionPlan 
                                                        plan={plan}  
                                                        isoneactive={isoneactive} 
                                                        isonestrill={isonestrill}
                                                        ispaastdue={isonepastdue}
                                                        subjectData={subjectData}

                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    )}                                             
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
        </div>      
    </div>
  )
}

export default StudentPlans
